module.exports = __webpack_public_path__ + "img/22.1eb6513f.png";